import React, {useState, useEffect} from 'react';
import Layout from '../components/layout';
import TextInput from '../components/text-input';
import TextArea from '../components/text-area';
import Hero from '../components/hero';

import '../styles/contact.css';
import check from '../images/checkmark.png';

const formFields = [
    {name: "firstName", label: "First Name", component: TextInput},
    {name: "lastName", label: "Last Name", component: TextInput},
    {name: "email", label: "Email", component: TextInput},
    {name: "phone", label: "Phone", component: TextInput},
    {name: "company", label: "Company", component: TextInput},
    {name: "message", label: "How can we help?", component: TextArea}
]

export default () => {

    let [contactInformation, setContactInformation] = useState({});
    let [reCaptcha, setReCaptcha] = useState({ready: false});
    let [formState, setFormState] = useState({loading: false, submitted: false});

    const handleFormChange = (e) => {
        setContactInformation({...contactInformation, [e.target.name]: e.target.value});
    }

    const submitForm = (e) => {
        e.preventDefault();
        const url = "https://c2c9du9gr0.execute-api.us-east-1.amazonaws.com/dev/contacts";
        let data = {...contactInformation, captcha: reCaptcha.instance.getResponse()}
        
        setFormState({...formState, loading: true});
        fetch(url, {
            method: "POST",
            mode: "cors",
            body: JSON.stringify(data)
        }).then(response => {
            setFormState({loading: false, submitted: true});
        }).catch(e => {
            setFormState({loading: false, submitted: true});
        });
    }

    //TODO see if it makes more sense to move this to a top level component. This will mean we have recaptcha available on all pages.
    //reasoning: the current unload only removes the script tag we add...there are other DOM elements added by reCaptcha that we may/may not need to clean up.
    //Observation: Seems like the script only binds to the "g-recaptcha" onLoad...if that div is removed from DOM it will not rebind when it is rendered again.

    //Effect for loading/unloading reCaptcha script
    useEffect(() => {
        const script = document.createElement('script');
        script.src = "https://www.google.com/recaptcha/api.js";
        script.async = true;
        script.defer = true;

        //onload of the script give form access to the grecaptcha object
        script.onload = () => {
            setReCaptcha({ready: true, instance: window.grecaptcha});
        }
        
        document.body.appendChild(script);
        return () => {
            //cleanup to remove the script when component unmounts
            document.body.removeChild(script);
        }
    }, [])

    const getForm = () => {
        return (
            <form>
                {
                    formFields.map(field => {
                        let {component:Component, ...rest} = field
                        return <Component key={rest.name} disabled={formState.loading} {...rest} onChange={handleFormChange} />
                    })
                }
                <div className="g-recaptcha" data-sitekey="6LfZVFcaAAAAAHIr43WoxzlocQKASPOFpTqhHMkV"></div>
                <button onClick={submitForm} disabled={formState.loading}>{formState.loading ? 'Sending...' : 'Send'}</button>
            </form>
        );
    }

    const getSuccessMessage = () => {
        return (
            <div className="successful-submission-container">
                <img src={check} />
                <h3>Thank You</h3>
                <p>Your submission has been received.</p>
            </div>
        );
    }

    return (
        <Layout active="contact">
            <Hero title="Contact Us" subtitle="Are you ready to see what we can do for you?" />
            <div className="contact-layout">
                {formState.submitted ? getSuccessMessage() : getForm()}
                <div className="contact-details">
                    <p>Marion, Texas</p>
                    {/* <p>(210)-555-5555</p> */}
                    <p>contact@fivelambdas.com</p>
                </div>
            </div>
        </Layout>
    )
}